// extracted by mini-css-extract-plugin
export default {"rowView":"ProductDialog_rowView__EV6X8","scrollHidden":"ProductDialog_scrollHidden__A2Kt+","verticalView":"ProductDialog_verticalView__lmNgV","button":"ProductDialog_button__Omfnx"};